import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ToastContainer } from 'react-toastify';
import ReactGA from 'react-ga4';
import { Chain, EthosConnectProvider } from 'ethos-connect';

import AppWrapper from './App';
import 'react-toastify/dist/ReactToastify.css';
import { DEV_TITLE_ID, TITLE_ID } from './Constants';

const gaTrackingID = TITLE_ID === DEV_TITLE_ID ? 'G-HW54GQEREB' : 'G-QN6M23G6N8';
ReactGA.initialize(gaTrackingID); // TODO: can change the analytics based on the environment!

const ethosConfiguration = TITLE_ID === DEV_TITLE_ID ? {
  apiKey: process.env.NEXT_PUBLIC_ETHOS_API_KEY,
  chain: Chain.SUI_TESTNET,
  preferredWallets: ['Ethos Wallet'],
  network: 'https://fullnode.testnet.sui.io:443',
  hideEmailSignIn: true,
} : {
  apiKey: process.env.NEXT_PUBLIC_ETHOS_API_KEY,
  chain: Chain.SUI_MAINNET,
  preferredWallets: ['Ethos Wallet'],
  network: 'https://fullnode.mainnet.sui.io:443',
  hideEmailSignIn: true,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EthosConnectProvider
      ethosConfiguration={ethosConfiguration}
      dappName="Run Legends"
      connectMessage="Log into your account"

    >
      <AppWrapper />
    </EthosConnectProvider>
    <ToastContainer containerId="an id" draggable={false} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
